import {
    AppProviders,
    AuthHydration,
    clientAuthStore,
    createQueryClient,
    type BemorBoot,
} from '@bemor/web-kit';
import { StaffAuthProvider } from '@bemor/web-kit/staff-auth';
import { ObjectHrefProvider, PageTitleProvider } from '@bemor/web-kit/ui';
import { useState, type ReactNode } from 'react';

import { STAFF_AUTH } from '@/lib/auth';
import { adminObjectHref } from '@/lib/object-href';

/** Admin's own providers inside the kit's (the server render and the browser both use them). */
export const wrap = (children: ReactNode) => (
    <StaffAuthProvider config={STAFF_AUTH}>
        {/* BM-46 §2.3: tab titles read "<page> · Admin". */}
        <PageTitleProvider suffix="Admin">
            {/* BM-46 §2.5: where an ObjectRef links to. */}
            <ObjectHrefProvider href={adminObjectHref}>
                {children}
            </ObjectHrefProvider>
        </PageTitleProvider>
    </StaffAuthProvider>
);

/** The app's providers for a browser-only tree (the tests); the live app hydrates through `hydrateApp`. */
export function App({
    children,
    boot,
}: {
    children: ReactNode;
    boot?: BemorBoot;
}) {
    const [client] = useState(() => createQueryClient(true));
    return (
        <AppProviders store={clientAuthStore} queryClient={client} wrap={wrap}>
            <AuthHydration boot={boot}>{children}</AuthHydration>
        </AppProviders>
    );
}
